import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { fetchFeaturedListings } from '../../ducks/featuredListings.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { getFeaturedListingsProps } from '../../util/data';

import { NamedRedirect } from '../../components';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import CommunityPage from './CommunityPage';
import CommunityRulesPage from './CommunityRulesPage';
import EventsPage from '../EventsPage/EventsPage';

const COMMUNITY_RULES_PAGE_ID = 'community-rules';
const SHELFY_SOCIAL_PAGE_ID = 'shelfy-social';
const DISCOVER_PAGE_ID = 'discover';
const EVENTS_PAGE_ID = 'events';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const { params, pageAssetsData, inProgress, error } = props;
  const pageId = params.pageId || props.pageId;

  if (pageId === SHELFY_SOCIAL_PAGE_ID) {
    return <CommunityPage />;
  }

  // /trending is the canonical Discover page; keep old /p/discover links working.
  if (pageId === DISCOVER_PAGE_ID) {
    return <NamedRedirect name="TrendingPage" />;
  }

  if (pageId === EVENTS_PAGE_ID) {
    return <EventsPage />;
  }

  if (pageId === COMMUNITY_RULES_PAGE_ID) {
    return <CommunityRulesPage />;
  }

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
      featuredListings={getFeaturedListingsProps(pageId, props)}
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const featuredListingData = state.featuredListings || {};

  const getListingEntitiesById = listingIds => getListingsById(state, listingIds);

  return { pageAssetsData, featuredListingData, getListingEntitiesById, inProgress, error };
};

const mapDispatchToProps = dispatch => ({
  onFetchFeaturedListings: (sectionId, parentPage, listingImageConfig, allSections) =>
    dispatch(fetchFeaturedListings({ sectionId, parentPage, listingImageConfig, allSections })),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CMSPageComponent);

export default CMSPage;
